const thresholds: { low: number; medium: number } = { low: 0.75, medium: 0.95 };

export const setSimilarityThresholds = (v: { low?: number; medium?: number } | undefined): void => {
  if (v?.low !== undefined) thresholds.low = v.low;
  if (v?.medium !== undefined) thresholds.medium = v.medium;
};

export const getSimilarityThresholds = (): Readonly<{ low: number; medium: number }> => thresholds;
